import script from "./Transferencias.vue?vue&type=script&setup=true&lang=js"
export * from "./Transferencias.vue?vue&type=script&setup=true&lang=js"

import "./Transferencias.vue?vue&type=style&index=0&id=e9ede020&scoped=true&lang=css"
import "./Transferencias.vue?vue&type=style&index=1&id=e9ede020&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9ede020"]])

export default __exports__